import { Col, Flex, Form, Grid } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import CalendarDemo from "../../../../../../assets/images/icons/CalendarDemo";
import Clock from "../../../../../../assets/images/icons/Clock";
import LocationDemo from "../../../../../../assets/images/icons/LocationDemo";
import SkiDemo from "../../../../../../assets/images/icons/SkiDemo";
import UserDemo from "../../../../../../assets/images/icons/UserDemo";
import {
  CalendarSelector,
  CountDropdown,
  ResortDropdown,
  SessionTypeSelector,
  SkillSelector,
} from "../../../../../../components";
import { PanelDateType } from "../../../../../../components/CalendarSelector/data";
import { InputRequired } from "../../../../../../validations/validations";
import { FilterProps } from "../../data";

const FullFilter: React.FC<FilterProps> = ({
  form,
  params,
  setParams,
  showHalfDaySelector,
  setShowHalfDaySelector,
  studentLimit,
  setStudentLimit,
}) => {
  const { t } = useTranslation();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const [panelDate, setPanelDate] = useState<PanelDateType>();

  // const fakeDivider = (
  //   <div
  //     style={{
  //       position: "absolute",
  //       right: screens.lg ? "-12px" : "-6px",
  //       top: "50%",
  //       transform: "translateY(-50%)",
  //       width: "1px",
  //       height: "50%",
  //       backgroundColor: "rgba(0, 0, 0, 0.2)",
  //     }}
  //   />
  // );

  return (
    <>
      <Col
        span={screens.sm ? 12 : 24}
        style={{ marginBottom: screens.sm ? 12 : 0 }}
      >
        <Form.Item name={"start_date"} hidden />
        <Form.Item name={"end_date"} hidden />
        <Flex align="center" gap={12} style={{ position: "relative" }}>
          <CalendarDemo
            style={{
              fontSize: screens.sm ? 32 : 20,
              color: "var(--Neutral-dark-50)",
              minWidth: screens.sm ? 32 : 20,
            }}
          />
          <Form.Item
            name={"date"}
            label={t("home.searchbar.date.title")}
            style={{ marginBottom: 0, flex: 1 }}
            rules={[InputRequired(t, "home.searchbar.date.title")]}
            className="filter-form-item"
          >
            <CalendarSelector
              setPanelDate={setPanelDate}
              schedule={[]}
              form={form}
              defaultOpen={false}
              needDisableDate={false}
            />
          </Form.Item>
          {/* {screens.sm && fakeDivider} */}
        </Flex>
      </Col>
      <Col span={12}>
        <Flex align="center" gap={12} style={{ position: "relative" }}>
          <SkiDemo
            style={{
              fontSize: screens.sm ? 32 : 20,
              color: "var(--Neutral-dark-50)",
              minWidth: screens.sm ? 32 : 20,
            }}
          />
          <Form.Item
            style={{ marginBottom: 0, flex: 1 }}
            name={"skill_type"}
            label={t("normal.skill.title")}
            rules={[InputRequired(t, "normal.skill.title")]}
            className="filter-form-item"
          >
            <SkillSelector form={form} />
          </Form.Item>
          {/* {!screens.sm && fakeDivider} */}
        </Flex>
      </Col>
      <Col
        span={screens.lg ? (showHalfDaySelector ? 8 : 12) : 12}
        style={{ marginBottom: screens.lg || !screens.sm ? 0 : 12 }}
      >
        <Flex align="center" gap={12} style={{ position: "relative" }}>
          <UserDemo
            style={{
              fontSize: screens.sm ? 32 : 20,
              color: "var(--Neutral-dark-50)",
              minWidth: screens.sm ? 32 : 20,
            }}
          />
          <Form.Item
            name={"count"}
            required
            label={t("normal.count.title")}
            style={{ marginBottom: 0, flex: 1 }}
            className="filter-form-item"
            rules={[
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (
                    Number(getFieldValue("adults")) === 0 &&
                    Number(getFieldValue("kids")) === 0
                  )
                    return Promise.reject(
                      new Error(
                        t("form.required", { name: t("normal.count.title") })
                      )
                    );
                  return Promise.resolve();
                },
              }),
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (
                    Number(getFieldValue("adults")) +
                      Number(getFieldValue("kids")) >
                    studentLimit
                  ) {
                    return Promise.reject(
                      new Error(
                        t("home.filter.count.error", { limit: studentLimit })
                      )
                    );
                  }
                  return Promise.resolve();
                },
              }),
            ]}
          >
            <CountDropdown
              form={form}
              params={params}
              setParams={setParams}
              studentLimit={studentLimit}
            />
          </Form.Item>
          {/* {screens.sm && fakeDivider} */}
        </Flex>
        <Form.Item hidden name={"adults"} />
        <Form.Item hidden name={"kids"} />
      </Col>
      <Col span={screens.lg ? (showHalfDaySelector ? 8 : 12) : 12}>
        <Flex align="center" gap={12} style={{ position: "relative" }}>
          <LocationDemo
            style={{
              fontSize: screens.sm ? 32 : 20,
              color: "var(--Neutral-dark-50)",
              minWidth: screens.sm ? 32 : 20,
            }}
          />
          <Form.Item
            style={{ marginBottom: 0, flex: 1 }}
            name={"locations"}
            label={t("home.searchbar.resort.title")}
            className="filter-form-item"
          >
            <ResortDropdown
              form={form}
              setShowHalfDaySelector={setShowHalfDaySelector}
              setStudentLimit={setStudentLimit}
            />
          </Form.Item>
          {/* {showHalfDaySelector && (screens.lg || !screens.sm) && fakeDivider} */}
        </Flex>
      </Col>
      {showHalfDaySelector && (
        <Col span={screens.lg ? 8 : 12}>
          <Flex align="center" gap={12} style={{ position: "relative" }}>
            <Clock
              style={{
                fontSize: screens.sm ? 32 : 20,
                color: "var(--Neutral-dark-50)",
                minWidth: screens.sm ? 32 : 20,
              }}
            />
            <Form.Item
              style={{ marginBottom: 0, flex: 1 }}
              name={"session_type"}
              label={t("normal.sessionType")}
              rules={[InputRequired(t, "normal.sessionType")]}
              className="filter-form-item"
            >
              <SessionTypeSelector form={form} />
            </Form.Item>
          </Flex>
        </Col>
      )}
    </>
  );
};

export default FullFilter;
